import { useMemo } from 'react';

import { Button, ExcelIcon, type TypeSelectOption } from '@thefarmersfront/kitchen';

import { Table, TableBottomField, TableTopField } from '~/components/common';

import { useStableCallback } from '~/hooks/common';
import { getReceiveReportListColumnDefs } from '~/utils';

import { RECEIVE_PAGE_SIZE } from '~/constants';

import type { TypePagination } from '~/types/common.types';
import type { TypeReceiveReportHistory } from '~/types/receive.types';

import styles from './ReceiveReportTable.module.scss';

const ReceiveReportTable = ({
  data,
  pagination,
  isDownloadReady,
  onClickReceiveReportExcelDownload,
  onChangePageLimit,
  onChangePage,
  onClickViewDetail,
}: {
  data: TypeReceiveReportHistory[] | null;
  pagination: TypePagination;
  isDownloadReady: boolean;
  onClickReceiveReportExcelDownload: () => void;
  onChangePageLimit: (value: TypeSelectOption<number>) => void;
  onChangePage: (value: number) => void;
  onClickViewDetail: (data: TypeReceiveReportHistory) => void;
}) => {
  // 부모 핸들러가 렌더마다 새 함수여도 컬럼(셀 함수)을 다시 만들지 않는다.
  const handleClickViewDetail = useStableCallback(onClickViewDetail);
  const { columnDefs } = useMemo(
    () => getReceiveReportListColumnDefs({ onClickViewDetail: handleClickViewDetail }),
    [handleClickViewDetail]
  );

  return (
    <div className={styles['table-container']}>
      <TableTopField
        dataTotalCount={pagination.totalCount}
        rightButton={
          <div className={styles['table-top-right-field']}>
            <Button
              size="tiny"
              variant="outlined"
              color="tertiary"
              disabled={!isDownloadReady}
              leftIcon={<ExcelIcon size={16} />}
              onClick={onClickReceiveReportExcelDownload}
            >
              엑셀 전체 다운로드
            </Button>
          </div>
        }
      />
      <div className={styles['table-wrapper']}>
        <Table data={data} columns={columnDefs} rowStatusType={data === null ? 'INIT' : 'EMPTY'} />
      </div>
      <TableBottomField
        pageSizeOptions={Object.values(RECEIVE_PAGE_SIZE)}
        currentPage={pagination.currentPage}
        totalCount={pagination.totalCount}
        pageSize={pagination.pageSize}
        onChangePageLimit={onChangePageLimit}
        onClickPage={(page) => onChangePage(page)}
      />
    </div>
  );
};

export default ReceiveReportTable;
